import React, { Component } from "react";
import { RequestHeaders } from "../../common/header-logo/request-header.component";
import { HeaderFilter } from "../../common/header-filter/header-filter.component";
import { DataTable } from "../../common/table/data-table/data-table-component";
import UserAccessDetails from "./details/manage-user-access/manage-user-access-details.component";
import { Header_Filter_Button_Label } from "../../../constants/internal-constants";
import { DetailsDataTable } from "../inventory/DetailsView/details-table/details-table.component";
import ManageUserDetails from "./details/manage-user/manage-user.details.component";
import ManageLocationDetails from "./details/manage-location/manage-location-details.component";
export class ManageLocation extends Component {
    constructor(props){
        super(props);
        this.state={
            viewDetailPage:false,
            selectedIndex:0,
            listSelected:"User Access"
        }
    }
    FilterIndex=(value)=>{
        this.setState({selectedIndex:value})
    }
    filterList=(value)=>{
        this.setState({listSelected:value})
    }
    getData=(value)=>{
        this.setState({viewDetailPage:value})
    }
    render(){
        const dropdownItem = ["Item 1", "Item 2", "Item 3"]
        const dataTable = [
            {
                HeaderItem: [
                    {
                        name: "Contract Name"
                    },
                    {
                        name: "Vendor"
                    }, {
                        name: "Status"
                    }, {
                        name: "Service Type"
                    }, {
                        name: "Effective Date"
                    }, {
                        name: "Expiration Date"
                    }
                ],
                dataItem: [{
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }, {
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }, {
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Active",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }, {
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }
                ]

            }
        ]
        const pages = {
            HasNext: true,
            HasPrevious: false,
            PageNumber: 0,
            PerPage: 21,
            TotalEntries: 2453,
            TotalPages: 123

        }
        const listItem={
            Tab:[
                {
                    "id":"0",
                    "label":"User Access"            
                },
                {
                    "id":"1",
                    "label":"User Rule"           
                }
            ]
        };
 
        const filtersub=[
            {key:31,
            value:"Change Location Address"},
            {key:5,value:"Change Price Plan"},
            {key:4,value:"Change User"},
            {key:14,value:"Change Vendor"},
            {key:29,value:"Change Vendor"},
            {key:27,value:"New Circuit"},
            {key:9,value:"New Mobile Subscription"},
            {key:32,value:"Other"}];

        const filterData = [
            {
                id:1,
                filterTitle:"Item 1",
                
            },
            {
                id:2,
                filterTitle:"Item 2",              
            },
            {
                id:3,
                filterTitle:"Item 3",              
            }, {       
                id:4,        
                filterTitle:"Item 4 with Checkbox",              
            }
        ]
        return(
            <div>
                 <RequestHeaders headerTitle="Manage Users" />   
                 {
                    this.state.viewDetailPage ?
                    <ManageLocationDetails closeForm={this.getData.bind(this)}/>
                    :
                    <div className="request-table data-table internal-data-table">
                        <HeaderFilter haveHeaderButton={false} enableDropdown={false} enableFilterBtn={true} filterData={filterData} filtersub={filtersub}  
                        dropdownItem={dropdownItem} enableExportExcel={this.state.selectedIndex===0 && true} 
                        enableAddBtn={false} enableUploadBtn={true} listSelected={this.state.listSelected} filterList={this.filterList} FilterIndex={this.FilterIndex} 
                        selectedIndex={this.state.selectedIndex} haveTab={false} />
                        {parseInt(this.state.selectedIndex)===0 ? dataTable.map((item, id) =>
                            <DataTable key={id} id={id} item={item} header={item.HeaderItem} getData={this.getData}  data={item.dataItem} isDataLoaded={true} customClassName="table-container" pages={pages} havePagination={true} />
                        ): 
                        <DetailsDataTable datatable={dataTable} haveToggle={true} haveEditBtn={true} haveDeleteBtn={true} /> 
                        }
                    </div>
                 }
                 
            
            </div>
        )
    }
}